import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React from "react";
import DragRail from "web/react/components/drag-rail/drag-rail";
import LazyImage from "web/react/components/lazy-load-image/lazy-load-image";
import Ticker from "web/react/components/ticker/ticker";
import analytics from "web/script/analytics/analytics";
import styles from "./top-lysts.css";

function TopLystItem(_ref) {
  var imgUrl = _ref.image_url,
      url = _ref.url,
      title = _ref.title;
  return React.createElement("a", {
    href: url,
    className: styles.item
  }, React.createElement("div", {
    className: styles.itemTitle
  }, React.createElement("h3", {
    className: styles.vertical
  }, title)), React.createElement(LazyImage, {
    src: imgUrl,
    alt: title,
    className: styles.itemImage
  }));
}

function TopLysts(_ref2) {
  var bannerRows = _ref2.banner_rows;

  var _bannerRows = _slicedToArray(bannerRows, 2),
      topRow = _bannerRows[0],
      bottomRow = _bannerRows[1];

  function handleDrag() {
    analytics.event("rail", "drag", "top-lysts");
  }

  return React.createElement("div", {
    className: styles.topLystsContainer
  }, React.createElement(Ticker, {
    speed: 50,
    className: styles.ticker
  }), React.createElement(DragRail, {
    onDragStart: handleDrag,
    className: styles.rail
  }, React.createElement("div", {
    className: styles.items
  }, topRow && topRow.map(function (item) {
    return React.createElement(TopLystItem, _extends({
      key: item.url
    }, item));
  }))), React.createElement(DragRail, {
    onDragStart: handleDrag
  }, React.createElement("div", {
    className: styles.items
  }, bottomRow && bottomRow.map(function (item) {
    return React.createElement(TopLystItem, _extends({
      key: item.url
    }, item));
  }))));
}

export default TopLysts;